export const store = {
  searchData:[],
  searchedTerm:'',  
  state: {
    year: 0,
    browser: '',
    showModal: '',
    showTopBtn: false,
    showMenu: false,
    contentView: 'overview',
    showDetailedInfo: true,
    currentDetailedTab: '',
    audioOn: false,
    audioInstructions: true
  },
  toggleModal(id = '') {
    /*
      If id is the same as modal already opened, then close existing modal. Otherwise open modal with id.
    */
    if (id === this.state.showModal) {
      this.state.showModal = '';
    } else {
      this.state.showModal = id;
    }
  },
  toggleDetailedInfo() {
    this.state.showDetailedInfo = !this.state.showDetailedInfo;
  },
  toggleContentView(view) {
    this.state.contentView = view;
  },
  toggleMenu() {
    this.state.showMenu = !this.state.showMenu;
  },
  updateYear(val) {
    this.state.year = val;
  },
  setDetailedTab(id) {
    this.state.currentDetailedTab = id;
  },
  toggleAudio(bool) {
    this.state.audioOn = bool;
  },
};

export { store as default };
